import { z } from 'zod';
import type { BaseEntity } from './common';
import type { Worker } from './worker';
import { IntegrationSystemEnum } from './integrationSystem';

/**
 * WorkerIntegration - Integrazione lavoratore
 * Rappresenta un'integrazione di un lavoratore con sistemi esterni
 * Corrisponde al modello backend WorkerIntegration
 */
export interface WorkerIntegration extends BaseEntity {
	/** ID del lavoratore sorgente */
	sourceId: number;
	/** Sistema di integrazione */
	system: IntegrationSystemEnum;
	/** Valore dell'integrazione nel sistema esterno (max 50 caratteri) */
	value: string;
	/** Lavoratore sorgente (navigation property, popolata con $expand=source) */
	source?: Worker;
}

/**
 * Schema Zod per la validazione runtime dei WorkerIntegration
 */
export const WorkerIntegrationSchema = z.object({
	id: z.number(),
	sourceId: z.number(),
	system: z.nativeEnum(IntegrationSystemEnum),
	value: z.string(),
	// Campi audit da BaseEntity - tutti presenti nel server response
	createdAt: z.string(),
	modifiedAt: z.string(), // Sempre presente nel server
	createdBy: z.string(),
	modifiedBy: z.string(), // Sempre presente nel server
	// Navigation property opzionale (non validata in runtime)
	source: z.any().optional(),
});
